import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

//packages
import { ClickOutsideModule } from 'ng-click-outside';
import { ApplicationinsightsAngularpluginErrorService } from '@microsoft/applicationinsights-angularplugin-js';

//components
import { HeaderComponent } from './components/header/header.component';
import { SidebarProfileComponent } from './components/sidebar-profile/sidebar-profile.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { FooterComponent } from './components/footer/footer.component';
import { UserTopComponent } from './components/user-top/user-top.component';
import { PagesHeaderComponent } from './components/pages-header/pages-header.component';
import { AlertComponent } from './components/alert/alert.component';

//components - dialog
import { InfoDialogComponent } from './components/shared/info-dialog/info-dialog.component';

//services
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpHandler, HttpRequest } from '@angular/common/http';
import { ApiservicesService } from './apiservices.service';
import { ErrorInterceptor } from './interceptor/error.interceptor';

//angular material
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatTableModule} from '@angular/material/table';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {CdkTreeModule} from '@angular/cdk/tree';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

//pages
import { UtamaComponent } from './pages/utama/utama.component';

//pages - pembayar cukai
import { PenerimaanPelantikanPermohonanOnlineComponent } from './pages/pembayar-cukai/penerimaan-pelantikan-permohonan-online/penerimaan-pelantikan-permohonan-online.component';
import { ButiranPenerimaanPelantikanPermohonanOnlineComponent } from './pages/pembayar-cukai/penerimaan-pelantikan-permohonan-online/butiran-penerimaan-pelantikan-permohonan-online/butiran-penerimaan-pelantikan-permohonan-online.component';
import { EBorangComponent } from './pages/pembayar-cukai/e-borang/e-borang.component';
import { StatusEBorangComponent } from './pages/pembayar-cukai/status-e-borang/status-e-borang.component';

//pages - integrasi
import { ProfilFirmaComponent } from './pages/integrasi/e-bas/profil-firma/profil-firma.component';
import { CetakDrafComponent } from './pages/integrasi/e-bas/cetak-draf/cetak-draf.component';
import { PenghantaranEBorangComponent } from './pages/integrasi/e-bas/penghantaran-e-borang/penghantaran-e-borang.component';
import { MitrsComponent } from './pages/integrasi/mitrs/mitrs.component';
import { EWhtComponent } from './pages/integrasi/e-wht/e-wht.component';
import { ECkhtComponent } from './pages/integrasi/e-ckht/e-ckht.component';
import { BorangBerulangComponent } from './pages/integrasi/borang-berulang/borang-berulang.component';
import { Mitrs2Component } from './pages/integrasi/mitrs2/mitrs2.component';
import { ESpcComponent } from './pages/integrasi/e-spc/e-spc.component';
import { EEotComponent } from './pages/integrasi/e-eot/e-eot.component';

//pages - penyenggaraan
import { DaftarKemaskiniComponent } from './pages/penyenggaraan/daftar-kemaskini/daftar-kemaskini.component';
import { ButiranDaftarKemaskiniComponent } from './pages/penyenggaraan/daftar-kemaskini/butiran-daftar-kemaskini/butiran-daftar-kemaskini.component';
import { CarianHubunganComponent } from './pages/penyenggaraan/carian-hubungan/carian-hubungan.component';
import { AgihanHubunganComponent } from './pages/penyenggaraan/agihan-hubungan/agihan-hubungan.component';
import { LogAuditComponent } from './pages/penyenggaraan/log-audit/log-audit.component';
import { AgihEBorangEjenCukaiComponent } from './pages/penyenggaraan/agih-e-borang-ejen-cukai/agih-e-borang-ejen-cukai.component';

//pages - bantuan sistem
import { BantuanEdtsComponent } from './pages/bantuan-sistem/bantuan-edts/bantuan-edts.component';

//pages - CP8D
import { Cp8dComponent } from './pages/cp8d/cp8d.component';
import { OauthCallbackComponent } from './pages/oauth-callback/oauth-callback.component';
import { OAuthModule } from 'angular-oauth2-oidc';



@NgModule({
  declarations: [
    AppComponent,
    
//components
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
    UserTopComponent,
    SidebarProfileComponent,
    PagesHeaderComponent,
    AlertComponent,

    //pages
    UtamaComponent,

    //pages - pembayar cukai
    PenerimaanPelantikanPermohonanOnlineComponent,
    ButiranPenerimaanPelantikanPermohonanOnlineComponent,
    EBorangComponent,
    StatusEBorangComponent,

    //pages - integrasi
    ProfilFirmaComponent,
    CetakDrafComponent,
    PenghantaranEBorangComponent,
    MitrsComponent,
    EWhtComponent,
    BorangBerulangComponent,
    Mitrs2Component,
    ECkhtComponent,
    ESpcComponent,

    //pages - penyenggaraan
    DaftarKemaskiniComponent,
    ButiranDaftarKemaskiniComponent,
    CarianHubunganComponent,
    AgihanHubunganComponent,
    LogAuditComponent,
    AgihEBorangEjenCukaiComponent,

    //pages - bantuan sistem
    BantuanEdtsComponent,

    //pages - CP8D
    Cp8dComponent,
    EEotComponent,
    OauthCallbackComponent,
    InfoDialogComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,

    //packages
    ClickOutsideModule,

    //angular material
    BrowserAnimationsModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatNativeDateModule,
    CdkTreeModule,
    DragDropModule,
    MatIconModule,
    MatCheckboxModule,
    MatDialogModule,
    MatButtonModule,
    OAuthModule.forRoot()
    
  ],
  providers: [
    UserTopComponent,
    ApiservicesService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    //{
    //  provide: ErrorHandler,
    //  useClass: ApplicationinsightsAngularpluginErrorService
    //}
  ],
  bootstrap: [AppComponent]
})

export class AppModule {

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const authReq = req.clone({
      setHeaders:
      {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache'
      }
    });
    return next.handle(authReq);
  }
}
